var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayGaleryPreview
    ? _c("div", [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-12 d-flex mb-2" }, [
              _c("div", { staticClass: "small fw-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("translate")("Photos")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ms-auto" }, [
                _c(
                  "a",
                  {
                    staticClass: "small",
                    attrs: { href: `/community/gallery${_vm.urlSuffix}` },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("translate")("See all")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.community_posts, function (post) {
              return _c("div", { key: post.id, staticClass: "col-4 mb-3" }, [
                _c("div", { staticClass: "ratio ratio-1x1" }, [
                  _c("div", { staticClass: "overflow-hidden rounded" }, [
                    _c("a", { attrs: { href: _vm.postLink(post) } }, [
                      _c("img", {
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "object-fit": "cover",
                        },
                        attrs: {
                          src: `https://djceg34j53tq.cloudfront.net/${post.image}`,
                        },
                      }),
                    ]),
                  ]),
                ]),
              ])
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }